import { Card, Icon, IconButton, Tooltip } from "@/components/atoms";
import { useAppDispatch } from "@/redux/hooks";
import { setAction } from "@/redux/slices/booking/bookingSlice";
import { BookingDetails } from "@/redux/slices/booking/types";
import { useIsOperatorOwnJob } from "../../../hooks/useIsOperatorOwnJob";
import { DetailField } from "../../../common/DetailField";

interface AttachmentsSectionProps {
  booking: BookingDetails;
}

export const AttachmentsSection = ({ booking }: AttachmentsSectionProps) => {
  const dispatch = useAppDispatch();
  const isOwnJob = useIsOperatorOwnJob();
  const { metadata, attachmentCount } = booking;

  if (metadata.isAcceptedFromNetwork) {
    return null;
  }

  if (metadata.isOffloaded && !isOwnJob) return null;

  const getAttachmentValue = () => {
    if (attachmentCount === 0) return "No attachments";
    if (attachmentCount === 1) return "1 total";
    return `${attachmentCount} total`;
  };

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="Paperclip2" size="lg" className="text-neutral-dark-gray" />}
        label="Attachments"
        value={getAttachmentValue()}
        right={
          <Tooltip content="View Job Attachments" placement="top">
            <IconButton
              iconName="ArrowRight"
              iconSize="md"
              size="xs"
              variant="primary"
              className="h-8 w-8"
              onClick={() => dispatch(setAction("job-attachments"))}
            />
          </Tooltip>
        }
      />
    </Card>
  );
};
